export const departmentsInFc = [
  'Finance',
  'Marketing',
  'Human Resources',
  'Operations',
  'Sales',
  'IT services',
  'Tech team',
  'Product Development',
  'Customer Support'
];
export const workModeInFC = ['Hybrid', 'Remote', 'Onsite', 'Full-time', 'Part-time'];
export const locationsInFc = ['Abuja', 'Lagos'];
export const experienceLevel = ['Entry level', 'Junior', 'Mid-level', 'Senior'];

export const parseBulletPoints = (text: string) => {
  return text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line.startsWith('-'))
    .map((line) => line.slice(1).trim());
};
